import { Table } from "antd";
import { useQuery } from "react-query";
import DashboardMaster from "../dashboard/dashboard-master-layout.component";
import React, { ReactElement } from "react";
import { getDiscountsList } from "./discount.thunks";
import { tableColumns } from "../../lib/helpers.table";
import { DiscountInterface } from "./discount.interface";

const DiscountList = (): ReactElement => {
  const moduleName = "discounts"; // we will use this as both the query name and the delete API endpoint
  const [page, setCurrentPage] = React.useState(0);

  const { data } = useQuery(
    [moduleName, { page }],
    () => getDiscountsList({ page }),
    { keepPreviousData: true }
  );

  const tableData = data ? data.docs : [];

  const pagination = {
    current: data?.page,
    pageSize: data?.limit,
    hideOnSinglePage: true,
    showSizeChanger: false,
    total: data?.totalDocs,
    onChange: (page) => {
      pagination.current = page; // updates table pagination
      setCurrentPage(page); // re-fetch the api
    },
  };

  const columnData = [
    "Code",
    "Value",
    {
      title: "Minimum Item",
      dataIndex: "minItem",
      sorter: (a, b) => {
        return a.minItem.toString().localeCompare(b.minItem.toString());
      },
    },
    {
      title: "Max Usage",
      dataIndex: "maxUse",
      sorter: (a, b) => {
        return a.maxUse.toString().localeCompare(b.maxUse.toString());
      },
    },
    {
      title: "Type",
      dataIndex: "type",
    },
  ];

  const columns = tableColumns(
    columnData,
    { field: "Code", url: `${moduleName}/` },
    { url: moduleName }
  );
  return (
    <>
      <DashboardMaster
        showAdd={true}
        title="Discounts"
        addUrl={`/dashboard/${moduleName}/new`}
      >
        <Table
          rowKey={(doc: DiscountInterface) => doc._id}
          columns={columns}
          dataSource={tableData}
          pagination={pagination}
        />
      </DashboardMaster>
    </>
  );
};

export default DiscountList;
